import type { AccountLockoutStatus } from "@/services/auth/types";

/** Remaining sign-in attempts before temporary lockout (0 when already locked). */
export function getAttemptsRemaining(status: AccountLockoutStatus): number {
  if (status.locked) {
    return 0;
  }
  return Math.max(0, status.maxAttempts - status.recentFailedAttempts);
}

/** User-facing hint after a failed sign-in when lockout is not yet active. */
export function formatAttemptsRemainingMessage(remaining: number): string | null {
  if (remaining <= 0) {
    return null;
  }
  if (remaining === 1) {
    return "1 attempt remaining before your account is temporarily locked for 15 minutes.";
  }
  return `${remaining} attempts remaining before your account is temporarily locked for 15 minutes.`;
}

/** Short toast title when the user is one step away from lockout. */
export function shouldWarnBeforeLockout(status: AccountLockoutStatus): boolean {
  return !status.locked && getAttemptsRemaining(status) <= 2;
}
